import { APIuuid, IAPIData } from '@shared/interfaces/api.interface';
import { IIntegrationsGreenhouse } from '@shared/interfaces/integrations/integrations.greenhouse.interface';

export class IntegrationsGreenhouse implements IIntegrationsGreenhouse {
  public static readonly TYPE: string = String(
    'ExternalAuthorisations::Greenhouse'
  );

  public id: APIuuid;
  public site_url: string;
  public user_id: string;
  public client_id: string;
  public client_secret: string;

  constructor(partial: Partial<IIntegrationsGreenhouse>) {
    Object.assign(this, partial);
  }

  public get apiData(): IAPIData {
    return {
      data: {
        type: IntegrationsGreenhouse.TYPE,
        id: this.id,
        attributes: {
          site_url: this.site_url,
          user_id: this.user_id,
          client_id: this.client_id,
          client_secret: this.client_secret
        }
      }
    } as IAPIData;
  }

  public static fromAPI(res: IAPIData): IIntegrationsGreenhouse {
    const data = res.data;
    const types = [IntegrationsGreenhouse.TYPE, 'ExternalAuthorisation'];

    if (!types.includes(data?.type)) {
      throw new Error(
        `There was a problem parsing ${IntegrationsGreenhouse.TYPE} API data`
      );
    }

    return new IntegrationsGreenhouse({
      id: data.id,
      ...data.attributes
    });
  }
}
